"use client";

/**
 * Backwards-compatible wrapper.
 * Prefer `useMediaAssetUpload` from `@/features/media/hooks`.
 */

import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { useMediaAssetUpload } from "@/features/media/hooks";

export const useTenantLogoUpload = (
  toast: ReturnType<typeof import("@/components/feedback").useToast>,
) => {
  const { mutateAsync, isPending, isError, isSuccess } = useMediaAssetUpload(toast);

  return {
    mutateAsync: (request: {
      tenantId: number;
      file: File;
      previousMediaId?: number | null;
    }) =>
      mutateAsync({
        tenantId: request.tenantId,
        ownerType: EntryType.Tenant,
        ownerId: request.tenantId,
        mediaGroup: MediaGroup.Logo,
        file: request.file,
        previousMediaId: request.previousMediaId,
      }),
    isPending,
    isError,
    isSuccess,
  };
};

